import { render } from "./RegForm.vue?vue&type=template&id=177d2a40"
import script from "./RegForm.vue?vue&type=script&lang=js"
export * from "./RegForm.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__